import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableBody,
} from '@mui/material';

import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../../components/common/Table';
import Button from '../../../../components/common/Button';
import { downloadCSVFile, subsidiesAmountTableToCSV } from '../../CSVFunctions';

export default function SubsidiesAmountTable(props) {
  const getCSV = () =>
    downloadCSVFile(
      subsidiesAmountTableToCSV(
        props.paymentTypeIncomeList.sort((a, b) => a.id - b.id)
      )
    );
  return (
    <>
      <Grid item xs={12} ref={props.subsidiesAmountTableRef}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Nazwa dopłaty</StyledTableCell>
                <StyledTableCell align="center">
                  Łączna powierzchnia zakwalifikowana pod daną dopłatę (ha)
                </StyledTableCell>
                <StyledTableCell align="center">
                  Łączny dochód uzyskany z danego typu dopłaty (zł)
                </StyledTableCell>
                <StyledTableCell align="center">
                  % Udziału zysku z danego typu dopłaty w gospodarstwie
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.paymentTypeIncomeList
                .sort((a, b) => a.id - b.id)
                .map((row) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell component="th" scope="row">
                      {row.name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {Number(row.area.toFixed(2))}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {Number(row.income.toFixed(2))}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {Number(row.percentageOfTotalIncome.toFixed(2))}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={5}>
        <Button
          type="submit"
          variant="contained"
          fullWidth
          onClick={getCSV}
          sx={{ mt: 3, mb: 7 }}
        >
          Eksportuj do CSV
        </Button>
      </Grid>
    </>
  );
}
